import { gql } from 'urql';

export const GET_USER_IDENTITY = gql`
  query GetUserIdentity {
    identity {
      user {
        fullName
        email
      }
    }
  }
`;
